import React, { useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import bibleIcon from "../../images/icons/1. bible.png";
import niigemIcon from "../../images/icons/2. niigem.png";
import ehoronIcon from "../../images/icons/3. ehoron.png";
import elegsegIcon from "../../images/icons/4. elegseg.png";
import oyunIcon from "../../images/icons/5. oyun.png";
import aImg from "../../images/map/map-about-tab.svg";
import aImg1 from "../../images/about/2-hajuu.png";
import aImg2 from "../../images/about/1-gol.png";
import aImg3 from "../../images/about/3-hajuu.png";
// import Services from "../../api/service";

const AboutTab = (props) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="about position-relative" id="feature">
      {/* <img src={aImg} alt="MСС" className="map-about-tab" /> */}
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="featureTab">
              <Nav tabs className="nav justify-content-center">
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "1" })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Эрхэм зорилго
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "2" })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    Баримтлах зарчим
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === "3" })}
                    onClick={() => {
                      toggle("3");
                    }}
                  >
                    Байгуулагдсан түүх
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="pt-35">
                <TabPane tabId="1">
                  <div className="row">
                    <div className="col-lg-10 mx-auto">
                      <div className="aboutDetails text-center">
                        <h5 className="aboutDetailsText mb-20">
                          Бидний зорилго сэтгэлдээ гэрэлтэй хүн, хайр дүүрэн
                          амар тайван гэр бүлийг бүтээх, сэтгэлийн хүчээ удирдаж
                          чадах эрүүл нийгмийг үгийн хүчээр цогцлооход оршино.
                        </h5>
                      </div>
                      <div className="aboutDetailsThumbs pt-35">
                        <div className="row g-0 align-items-center">
                          <div className="col-lg-4">
                            <div className="aboutDetailsThumb">
                              <img src={aImg1} alt="About mongolsuvd" />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="aboutDetailsThumb aboutDetailsThumb--big">
                              <img src={aImg2} alt="About mongolsuvd" />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="aboutDetailsThumb">
                              <img src={aImg3} alt="About mongolsuvd" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div className="row">
                    <div className="col-lg-10 mx-auto">
                      <div className="service pt-30 pb-0">
                        <div className="container">
                          {/* Дээд эгнээ - 3 багана */}
                          <div className="row">
                            <div className="col-lg-4 col-md-4">
                              <div className="keyFeatureBlock keyFeatureBlock--style4 mb-30">
                                <div className="keyFeatureBlock__left">
                                  <span className="keyFeatureBlock__icon">
                                    <img src={bibleIcon} alt="bible" />
                                  </span>
                                </div>
                                <div className="keyFeatureBlock__content">
                                  <h3 className="keyFeatureBlock__heading">
                                    <p className="keyFeatureBlock__heading__link">
                                      1. Библийн сургаалыг баримтлах
                                    </p>
                                  </h3>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="keyFeatureBlock keyFeatureBlock--style4 mb-30">
                                <div className="keyFeatureBlock__left">
                                  <span className="keyFeatureBlock__icon">
                                    <img src={niigemIcon} alt="niigem" />
                                  </span>
                                </div>
                                <div className="keyFeatureBlock__content">
                                  <h3 className="keyFeatureBlock__heading">
                                    <p className="keyFeatureBlock__heading__link">
                                      2. Нийгмийн амьдралд идэвхтэй оролцох
                                    </p>
                                  </h3>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4">
                              <div className="keyFeatureBlock keyFeatureBlock--style4 mb-30">
                                <div className="keyFeatureBlock__left">
                                  <span className="keyFeatureBlock__icon">
                                    <img src={ehoronIcon} alt="ehoron" />
                                  </span>
                                </div>
                                <div className="keyFeatureBlock__content">
                                  <h3 className="keyFeatureBlock__heading">
                                    <p className="keyFeatureBlock__heading__link">
                                      3. Эх орныхоо төлөө чин эрмэлзэлтэй бие
                                      хүн болж төлөвших
                                    </p>
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Доод эгнээ - 2 багана */}
                          <div className="row">
                            <div className="col-lg-6 col-md-6">
                              <div className="keyFeatureBlock keyFeatureBlock--style4 mb-30">
                                <div className="keyFeatureBlock__left">
                                  <span className="keyFeatureBlock__icon">
                                    <img src={elegsegIcon} alt="elegseg" />
                                  </span>
                                </div>
                                <div className="keyFeatureBlock__content">
                                  <h3 className="keyFeatureBlock__heading">
                                    <p className="keyFeatureBlock__heading__link">
                                      4. Элэгсэг, энэрэнгүй, төлөв даруу байх
                                    </p>
                                  </h3>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                              <div className="keyFeatureBlock keyFeatureBlock--style4 mb-30">
                                <div className="keyFeatureBlock__left">
                                  <span className="keyFeatureBlock__icon">
                                    <img src={oyunIcon} alt="oyun" />
                                  </span>
                                </div>
                                <div className="keyFeatureBlock__content">
                                  <h3 className="keyFeatureBlock__heading">
                                    <p className="keyFeatureBlock__heading__link">
                                      5. Оюун санааны өргөн мэдлэгтэй байх
                                    </p>
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="3">
                  <div className="row">
                    <div className="col-lg-10 mx-auto">
                      <div className="aboutDetails text-center">
                        <p className="aboutDetailsText mb-0">
                          <strong>Монгол сувд сүм</strong> нь нийслэлийн
                          иргэдийн төлөөлөгчдийн хурлын{" "}
                          <strong>
                            2016 оны 05 дугаар сарын 6-ны өдрийн 83 дугаар
                          </strong>{" "}
                          Шашны байгууллагад зөвшөөрөл олгох тухай тогтоолын
                          үндсэн дээр{" "}
                          <strong> 2016 оны 05 дугаар сарын 20</strong>-ны өдөр{" "}
                          <strong>
                            Улсын бүртгэлийн 9080002146 тоот гэрчилгээ
                          </strong>
                          ний дагуу үйл ажиллагаагаа явуулдаг билээ. Үндсэн
                          эрхлэх үйл ажиллагааны чиглэл нь сүсэгтэн олны шашин,
                          хурал номын эрэлт хэрэгцээг хангах үйл ажиллагааг
                          хууль тогтоомжийн хүрээнд эрхлэх бөгөөд одоогийн
                          байдлаар нийт <strong>10,000 </strong>орчим итгэгч,
                          дагалдагчидтай үйл ажиллагаагаа явуулж байна. Манай
                          сүм нь Христийн сүм бөгөөд гол баримтлах сургаал,
                          судар нь <strong>БИБЛИЙН судар</strong> юм. Мөн сүмийн
                          үүсгэн байгуулах дүрэмдээ гишүүдээ хамруулсан албан
                          бус сургалтын зохион байгуулах, Нийгмийн хариуцлагын
                          хүрээнд зорилтот бүлэг руу чиглэсэн үйл ажиллагааг
                          зохион байгуулах зэргээр үйл ажиллагааны чиглэлээ
                          тодорхойлсон бөгөөд энэ чиглэлийн дагуу тодорхой
                          ажлуудыг зохион байгуулж ирсэн.
                        </p>
                      </div>
                      <div className="aboutDetailsThumbs pt-40">
                        <div className="row g-0 align-items-center">
                          <div className="col-lg-4">
                            <div className="aboutDetailsThumb">
                              <img src={aImg1} alt="About Gainioz" />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="aboutDetailsThumb aboutDetailsThumb--big">
                              <img src={aImg2} alt="About Gainioz" />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="aboutDetailsThumb">
                              <img src={aImg3} alt="About Gainioz" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutTab;
